import { Component } from "react"
import PropTypes from "prop-types"
import { find, filter, size, get } from "lodash"
import { Card, CardContent, Typography } from "@mui/material"
import LoadingCard from "components/loading-card"
import ResourcesChip from "components/resources-chip"
import { FundList, ImportButton } from "./components"
import { RESOURCE_LIMITS } from "helpers/shapes"
import { RESOURCES_PER_AT_FUND } from "helpers/op-pro"

import "./style.scss"

export default class AlphaTheory extends Component {
  static propTypes = {
    account: PropTypes.string.isRequired,
    fetchFunds: PropTypes.func.isRequired,
    importFunds: PropTypes.func.isRequired,
    importing: PropTypes.bool.isRequired,
    connected: PropTypes.bool.isRequired,
    funds: PropTypes.object.isRequired,
    resourceLimits: RESOURCE_LIMITS,
    isOpPro: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      toImport: [],
    }
  }

  componentDidMount() {
    const { connected, fetchFunds } = this.props
    if (connected) {
      fetchFunds()
    }
  }

  importFunds = () => {
    const { importFunds: importAction } = this.props
    const { toImport } = this.state
    importAction(toImport)
  }

  contactUsAuth = () => {
    const { account } = this.props
    window.Intercom("showNewMessage", `Hello Omega Point, I am interested in authenticating the Alpha Theory integration for the account "${account}". Please reply with next steps, including connecting with Alpha Theory to obtain login credentials for this integration.`)
  }

  contactUsFundList = () => {
    const { account } = this.props
    window.Intercom("showNewMessage", `Hello Omega Point, I am currently experiencing issues with the Alpha Theory import for the account "${account}".`)
  }

  toggleFund = (fund) => () => {
    const { toImport } = this.state
    const { fundId: id } = fund
    let newToImport

    const existing = find(toImport, ({ fundId }) => id === fundId)
    if (existing) {
      newToImport = filter(toImport, ({ fundId }) => id !== fundId)
    } else {
      newToImport = [...toImport, fund]
    }
    this.setState({ toImport: newToImport })
  }

  getAuthenticatedStatus = () => {
    const { connected } = this.props
    if (connected) {
      return {
        color: "success",
        text: "Connected",
      }
    }

    return {
      color: "warning",
      text: "Not connected",
    }
  }

  getFundListStatus = () => {
    const { funds } = this.props
    const { loading, error } = funds

    if (loading) {
      return {
        text: "Requesting list...",
        color: "primary",
      }
    }

    if (error) {
      return {
        text: "Error",
        color: "error",
      }
    }

    return {
      text: "List received",
      color: "success",
    }
  }

  render() {
    const { toImport } = this.state
    const { connected, funds, importing, resourceLimits, isOpPro } = this.props
    const availableResourceSlots = get(resourceLimits, "available")

    return <div className="modules_alpha-theory">
      <div className="content">
        <Card square>
          <div className="header no-loader">
            <Typography variant="h2" color="textPrimary" gutterBottom>
              About this app
            </Typography>
          </div>
          <CardContent>
            <Typography>
              This integration allows mutual customers to import their portfolios and forecasts from Alpha Theory into Omega Point&apos;s ecosystem on a daily basis.
            </Typography>
          </CardContent>
        </Card>

        <LoadingCard title="Authentication" status={this.getAuthenticatedStatus()} visible={!connected} className="authentication">
          <Typography>
            Omega Point has been notified that this application has been activated and will reach out to you to request credentials to authenticate the Alpha theory integration on this account. Or reach out to <a onClick={this.contactUsAuth}>Customer Success</a> directly to follow-up.
          </Typography>
          <Typography variant="subtitle2" color="textSecondary">Note: once activated, this integration is enabled across the entire account. As resources are created, account administrators can restrict access through permissions.</Typography>
        </LoadingCard>

        <LoadingCard title="Select funds for historical import" status={this.getFundListStatus()} visible={connected && !funds.loading} loading={funds.loading} className="import" disabled={!connected}>
          {funds.error
            ? <Typography>An error occured while fetching the data from Alpha Theory. <br />Please contact <a onClick={this.contactUsFundList}>Customer Success</a> if the error persists.</Typography>
            : <>
              <ResourcesChip resourceLimits={resourceLimits} newResourceCount={size(toImport) * RESOURCES_PER_AT_FUND} />
              <FundList funds={funds.items} toggleFund={this.toggleFund} toImport={toImport} availableResourceSlots={availableResourceSlots} isOpPro={isOpPro} />
            </>}
          <ImportButton {...{ connected, funds, importing, toImport, importFunds: this.importFunds }} />
        </LoadingCard>
      </div>
    </div>
  }
}
